import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

/**
 * Get the CSS class for the status dot based on presence status.
 * Returns: "chat-avatar__dot--online", "chat-avatar__dot--away", etc.
 */
export const getStatusDotClass = (status) => {
  switch (status) {
    case "online": return "chat-avatar__dot--online";
    case "away": return "chat-avatar__dot--away";
    case "busy": return "chat-avatar__dot--busy";
    case "dnd": return "chat-avatar__dot--dnd";
    default: return "chat-avatar__dot--offline";
  }
};

/**
 * Get the CSS class for the header status text.
 */
export const getStatusTextClass = (status) => {
  switch (status) {
    case "online": return "chat-header__status--online";
    case "away": return "chat-header__status--away";
    case "busy":
    case "dnd": return "chat-header__status--busy";
    default: return "";
  }
};

/**
 * Get human-readable status label (like Microsoft Teams).
 */
export const getStatusLabel = (status, customStatus, lastSeen) => {
  if (customStatus) return customStatus;
  switch (status) {
    case "online": return "Online";
    case "away": return "Away";
    case "busy": return "Busy";
    case "dnd": return "Do not disturb";
    case "offline":
      if (lastSeen) return `Last seen ${dayjs(lastSeen).fromNow()}`;
      return "Offline";
    default:
      return "Offline";
  }
};

/**
 * Status options for the manual status picker.
 */
export const STATUS_OPTIONS = [
  { value: "online", label: "Online", color: "#22c55e", icon: "●" },
  { value: "away", label: "Away", color: "#f59e0b", icon: "●" },
  { value: "busy", label: "Busy", color: "#ef4444", icon: "●" },
  { value: "dnd", label: "Do not disturb", color: "#ef4444", icon: "⛔" },
];
